import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Check if analytics cookies are allowed
    const cookiePreferences = localStorage.getItem('cookiePreferences');
    let analyticsEnabled = false;

    if (cookiePreferences) {
      try {
        const preferences = JSON.parse(cookiePreferences);
        analyticsEnabled = preferences?.analytics === true;
      } catch (e) {
        console.error('Failed to parse cookie preferences:', e);
      }
    }

    // Only initialize GA if analytics cookies are enabled
    if (!analyticsEnabled) {
      console.log('Google Analytics disabled - analytics cookies not accepted');
      return;
    }

    const measurementId = import.meta.env?.VITE_GA_MEASUREMENT_ID;

    if (!measurementId || measurementId === 'your-google-analytics-id-here') {
      console.warn('Google Analytics Measurement ID not configured');
      return;
    }

    // Initialize GA if not already loaded
    if (!window.dataLayer) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.async = true;
      document.head?.appendChild(script);

      window.dataLayer = [];
      window.gtag = function gtag(...args) {
        window.dataLayer?.push(...args);
      };
      window.gtag('js', new Date());
      window.gtag('config', measurementId, {
        anonymize_ip: true, // GDPR compliance
        cookie_flags: 'SameSite=None;Secure'
      });
    }

    // Track page view on route change
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location?.pathname + location?.search,
        page_title: document.title
      });
    }
  }, [location]);
}

// Component wrapper to use inside BrowserRouter
export function GoogleAnalyticsTracker() {
  useGoogleAnalytics();
  return null;
}

export default useGoogleAnalytics;